const my_profile = {
  viewMyClubSeacretProfile: "הצג את פרופיל ClubSeacret שלי", // translated
  viewMoreDetails: "הצג פרטים נוספים", // translated
  verifiedEmail: "אימייל מאומת", // translated
  unverifiedEmail: "אימייל לא מאומת", // translated
};

export default my_profile;
